export default __webpack_public_path__ + "static/media/camera.c9c85458.png";